export const getDataSystemType = (type: number) => (type === 1 ? 'database' : 'system')
